//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Illustration from '@/assets/illustrations/bug-fixing.svg';
import Logo from '@/assets/img/primary-logo-blue.svg';

export default {
  name: 'MaintenancePage',
  data() {
    return {
      Logo,
      Illustration,
    };
  },
};
